<template>
  <kit type="pages" />
</template>
<script>
import Kit from "../Kit";

export default {
  name: "categories_kit",
  components: {
    Kit,
  },
};
</script>
<style>
</style>
